import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-arch-stack',
	templateUrl:'./StackDiagramPage.html',
	styles: [],
	styleUrls:['./StackDiagramPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class StackDiagramPage
{
	mdContent_26 = `\`\`\`mermaid
block-beta
  columns 1
  block:app["YOUR APPLICATION"]
    columns 3
    a1["@NgComponent"] a2["@NgRoutable"] a3["@NgDataService"]
  end
  space
  block:plugins["PLUGINS & COMPONENTS"]
    columns 3
    p1["WebAwesome"] p2["AG Grid"] p3["Charts"]
    p4["RabbitMQ"] p5["Font Awesome"] p6["Calendar"]
  end
  space
  block:core["JWEBMP CORE"]
    columns 3
    c1["HTML Elements"] c2["CSS Builder"] c3["Events"]
    c4["AJAX Pipeline"] c5["Angular Generator"] c6["TS Compiler"]
  end
  space
  block:foundation["GUICEDEE FOUNDATION"]
    columns 3
    f1["Google Guice DI"] f2["SPI Discovery"] f3["JPMS"]
    f4["Vert.x 5 HTTP"] f5["Event Bus"] f6["Call Scopes"]
  end
  app --> plugins --> core --> foundation

\`\`\``;
}
